import React, { Component } from 'react';
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action, fill_master_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, stalltypeMasterListActionId, dashboardDownloadListId, countryMasterListActionId, toastSuccess, paymentMasterListActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Exh_chapter from '../exh_chapter/exh_chapter';
import Resizer from "react-image-file-resizer";
// import ManageArea from './manage_area/manage_area';
import Exh_timeline from '../exh_timeline/exh_timeline';
import ManageAreaMaster from '../manage_area_master/manage_area_master';
import ManualFormsMaster from "../manual_froms_master/manual_forms_master";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import {
    getPartnerMaster_action, updatePartnerMaster_action, getPartnerNote_action, updatePartnerNote_action
} from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/partner_master_action";

class PartnerMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            ExihibitionID: '',
            partnerList: [],
            partnerOfferNoteList: [],
            partnerTandCNoteList: [],
            mode: 0,
            selectedPartnerId: '',
            allNoteData: [],
        }
        this.getPartnerMaster = this.getPartnerMaster.bind(this)
        this.renderTable = this.renderTable.bind(this)
        this.onCodeChange = this.onCodeChange.bind(this)
        this.onAddNotes = this.onAddNotes.bind(this)
        this.getPartnerNote = this.getPartnerNote.bind(this)
        this.onDescriptionChange = this.onDescriptionChange.bind(this)
        this.onAddSubNote = this.onAddSubNote.bind(this)
        this.updateNote = this.updateNote.bind(this)

    }

    componentDidMount() {
        this.setState({
            ExihibitionID: this.props.location.state.ExihibitionID != undefined ? (this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : '') : this.props.id != null && this.props.id != undefined ? this.props.id : '',
        }, () => {
            this.getPartnerMaster()
        })
    }

    getPartnerMaster() {
        const { ExihibitionID, allocateStalltypeList, allocateCountryList } = this.state
        this.setState({ isLoading: true })
        this.props.getPartnerMaster_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        partnerList: data.data,
                        isLoading: false
                    })
                }
            })
    }

    getPartnerNote(id) {
        const { ExihibitionID, allocateStalltypeList, allocateCountryList } = this.state
        this.setState({ isLoading: true })
        this.props.getPartnerNote_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    // var partnerTypeIDList = []
                    // var list = []
                    // // data.data.map(item => {
                    // //     if (!partnerTypeIDList.includes(item.PartnerTypeID)) {
                    // //         partnerTypeIDList.push(item.PartnerTypeID)
                    // //     }
                    // // })
                    data.data.length > 0 && data.data.sort((a, b) => a.PartnerTypeID - b.PartnerTypeID)
                    console.log(data.data)
                    this.setState({
                        allNoteData: data.data
                    })
                    var offerlist = []
                    var TandClist = []
                    data.data.map(item => {
                        if (item.PartnerTypeID == id) {
                            if (item.IsOffer) {
                                offerlist.push(item)
                            } else if (item.IsTermAndCondition) {
                                TandClist.push(item)
                            }
                        }
                    })
                    this.setState({
                        partnerOfferNoteList: offerlist,
                        partnerTandCNoteList: TandClist,
                        isLoading: false
                    })
                }
            })
    }

    onCodeChange(e, id) {
        const { ExihibitionID, allocateStalltypeList, allocateCountryList, partnerList } = this.state
        var value = e.target.value
        for (var i = 0; i < partnerList.length; i++) {
            if (partnerList[i].PartnerTypeID == id) {
                partnerList[i].Code = value
            }
        }
        this.setState({
            partnerList: partnerList
        })
    }

    onAddNotes(id) {
        const { ExihibitionID, allocateStalltypeList, mode, selectedPartnerId, allocateCountryList, partnerList } = this.state
        this.setState({
            mode: 1,
            selectedPartnerId: id
        }, () => {
            this.getPartnerNote(id)
        })
    }

    renderTable(record) {
        return (
            <>
                <div className="row exb-top-space mx-2">
                    <div class=" col-md-6 px-0">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3">
                            <thead>
                                <tr>
                                    <th className="text-center">Sr no.</th>
                                    <th className="text-center">Partner Type</th>
                                    <th className="text-center">Code</th>
                                    <th className="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    record.length > 0 ? <>{
                                        record.map((data, ID) => (
                                            <tr key={ID}>
                                                <td className="text-center">
                                                    {ID + 1}
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        disabled={true}
                                                        value={data.Name}
                                                    />
                                                </td>
                                                <td className="text-center" >
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        value={data.Code}
                                                        // disabled={true}
                                                        onChange={(e) => this.onCodeChange(e, data.PartnerTypeID)}
                                                    />
                                                </td>
                                                <td className="text-center" >
                                                    <button
                                                        // onClick={() => this.updateExhibitionPaymentConfigration()}
                                                        onClick={() => this.onAddNotes(data.PartnerTypeID)}
                                                        class="btn rounded-1 btn-aqua mt-2">Add Notes</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </> :
                                        <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div></>
        )
    }


    getWriteAccess() {
        const { loginAccesslist } = this.state
        if (JSON.parse(sessionStorage.getItem('loginDataSS')).UserID == 233) {
            return false
        } else {
            return true
        }
    }

    onDescriptionChange(e, flag, id) {
        const { ExihibitionID, allocateStalltypeList, mode, selectedPartnerId, partnerOfferNoteList, partnerTandCNoteList, allocateCountryList, partnerList } = this.state
        var value = e.target.value
        if (flag == 0) {
            for (var i = 0; i < partnerOfferNoteList.length; i++) {
                if (partnerOfferNoteList[i].SeqNo == id) {
                    partnerOfferNoteList[i].Description = value
                }
            }
            this.setState({
                partnerOfferNoteList: partnerOfferNoteList
            })
        } else if (flag == 1) {
            for (var i = 0; i < partnerTandCNoteList.length; i++) {
                if (partnerTandCNoteList[i].SeqNo == id) {
                    partnerTandCNoteList[i].Description = value
                }
            }
            this.setState({
                partnerTandCNoteList: partnerTandCNoteList
            })
        }
    }

    onAddSubNote(seq, flag) {
        const { ExihibitionID, allocateStalltypeList, mode, selectedPartnerId, partnerOfferNoteList, partnerTandCNoteList, allocateCountryList, partnerList } = this.state
        var totalSubpoints = 0
        if (flag == 0) {
            for (var i = 0; i < partnerOfferNoteList.length; i++) {
                if (partnerOfferNoteList[i].parent_id == seq) {
                    totalSubpoints = totalSubpoints + 1
                }
            }
        } else if (flag == 1) {
            for (var i = 0; i < partnerTandCNoteList.length; i++) {
                if (partnerTandCNoteList[i].parent_id == seq) {
                    totalSubpoints = totalSubpoints + 1
                }
            }
        }
        let letter = String.fromCharCode(97 + totalSubpoints);
        var newSeqNo = `${seq}.${letter}`

        var obj = {
            'PartnerTypeID': selectedPartnerId,
            'Description': '',
            'SeqNo': newSeqNo,
            'IsOffer': flag == 0,
            'IsTermAndCondition': flag == 1,
            'parent_id': seq
        }
        console.log(obj)

        var index
        if (flag == 0) {
            for (var i = 0; i < partnerOfferNoteList.length; i++) {
                if (partnerOfferNoteList[i].SeqNo == seq) {
                    index = i
                }
            }

        } else if (flag == 1) {
            for (var i = 0; i < partnerTandCNoteList.length; i++) {
                if (partnerTandCNoteList[i].SeqNo == seq) {
                    index = i
                }
            }
        }
        if (flag == 0) {
            partnerOfferNoteList.splice(index + parseInt(totalSubpoints) + 1, 0, obj)
            this.setState({
                partnerOfferNoteList: partnerOfferNoteList,
            })
        } else if (flag == 1) {
            partnerTandCNoteList.splice(index + parseInt(totalSubpoints) + 1, 0, obj)
            this.setState({
                partnerTandCNoteList: partnerTandCNoteList,
            })
        }

    }

    onDelete(index, seq, parentID, flag) {
        const { isLoading, partnerList, allNoteData, mode, ExihibitionID, partnerOfferNoteList, selectedPartnerId, partnerTandCNoteList } = this.state
        console.log(index, seq, parentID, flag)
        if (flag == 0) {
            if (parentID == 0) {
                var groupArr = []
                groupArr.push(parseInt(seq))
                for (var i = 0; i < partnerOfferNoteList.length; i++) {
                    if (parseInt(partnerOfferNoteList[i].parent_id) == parseInt(seq)) {
                        groupArr.push((partnerOfferNoteList[i].SeqNo))
                    }
                }
                partnerOfferNoteList.splice(index, groupArr.length)
                console.log(partnerOfferNoteList)
                var newSeqNo = 1
                for (var i = 0; i < partnerOfferNoteList.length; i++) {
                    if (partnerOfferNoteList[i].parent_id == 0) {
                        partnerOfferNoteList[i].SeqNo = `${newSeqNo}`
                        newSeqNo = newSeqNo + 1
                    } else {
                        newSeqNo = newSeqNo - 1
                        var letter = partnerOfferNoteList[i].SeqNo.split('.')[1]
                        partnerOfferNoteList[i].SeqNo = `${newSeqNo}.${letter}`
                        partnerOfferNoteList[i].parent_id = newSeqNo
                        newSeqNo = newSeqNo + 1
                    }
                }
            } else {
                partnerOfferNoteList.splice(index, 1)
                var subCount = 0
                for (var i = 0; i < partnerOfferNoteList.length; i++) {
                    if (partnerOfferNoteList[i].parent_id == parentID) {
                        partnerOfferNoteList[i].SeqNo = `${parentID}.${String.fromCharCode(97 + subCount)}`
                        subCount = subCount + 1
                    }
                }
            }
            this.setState({
                partnerOfferNoteList: partnerOfferNoteList
            }
                // , (this.updateNote())
            )
        } else if (flag == 1) {
            if (parentID == 0) {
                var groupArr = []
                groupArr.push(parseInt(seq))
                for (var i = 0; i < partnerTandCNoteList.length; i++) {
                    if (partnerTandCNoteList[i].parent_id == parseInt(seq)) {
                        groupArr.push(parseInt(partnerTandCNoteList[i].SeqNo))
                    }
                }
                console.log(groupArr, partnerTandCNoteList)
                partnerTandCNoteList.splice(index, groupArr.length)
                var newSeqNo = 1
                for (var i = 0; i < partnerTandCNoteList.length; i++) {
                    if (partnerTandCNoteList[i].parent_id == 0) {
                        partnerTandCNoteList[i].SeqNo = `${newSeqNo}`
                        newSeqNo = newSeqNo + 1
                    } else {
                        newSeqNo = newSeqNo - 1
                        var letter = partnerTandCNoteList[i].SeqNo.split('.')[1]
                        partnerTandCNoteList[i].SeqNo = `${newSeqNo}.${letter}`
                        partnerTandCNoteList[i].parent_id = newSeqNo
                        newSeqNo = newSeqNo + 1
                    }
                }
            } else {
                partnerTandCNoteList.splice(index, 1)
                var subCount = 0
                for (var i = 0; i < partnerTandCNoteList.length; i++) {
                    if (partnerTandCNoteList[i].parent_id == parentID) {
                        partnerTandCNoteList[i].SeqNo = `${parentID}.${String.fromCharCode(97 + subCount)}`
                        subCount = subCount + 1
                    }
                }
            }
            this.setState({
                partnerTandCNoteList: partnerTandCNoteList
            }
                // , (this.updateNote())
            )
        }
    }

    renderOfferNotesTable(record) {
        return (
            <>
                <div className="row mt-0">
                    <div class=" col-md-12">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-0">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }} className="text-center">Sr no.</th>
                                    <th className="text-center">Description</th>
                                    <th style={{ width: '50px' }} className="text-center"></th>
                                    <th style={{ width: '50px' }} className="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    record.length > 0 ? <>{
                                        record.map((data, ID) => (
                                            <tr key={ID}>
                                                <td className="text-center">
                                                    {data.SeqNo}
                                                </td>
                                                <td>
                                                    {/* <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        // disabled={true}
                                                        value={data.Description}
                                                        onChange={(e) => this.onDescriptionChange(e, data.SeqNo)}
                                                    /> */}
                                                    <textarea className="form-control" value={data.Description} onChange={(e) => this.onDescriptionChange(e, 0, data.SeqNo)}></textarea>
                                                </td>
                                                <td className="text-center" >
                                                    {data.parent_id == 0 && <button
                                                        // onClick={() => this.updateExhibitionPaymentConfigration()}
                                                        onClick={() => this.onAddSubNote(data.SeqNo, 0)}
                                                        class="btn rounded-1 btn-aqua  mt-2">Add SubNote</button>}
                                                </td>
                                                <td className="text-center">
                                                    {<button
                                                        // onClick={() => this.updateExhibitionPaymentConfigration()}
                                                        onClick={() => this.onDelete(ID, data.SeqNo, data.parent_id, 0)}
                                                        class="btn rounded-0 btn-danger mt-2">Delete</button>}
                                                </td>
                                            </tr>
                                        ))}
                                    </> :
                                        <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div ></>
        )
    }

    renderTandCNotesTable(record) {
        return (
            <>
                <div className="row mt-0">
                    <div class=" col-md-12">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-0">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }} className="text-center">Sr no.</th>
                                    <th className="text-center">Description</th>
                                    <th style={{ width: '50px' }} className="text-center"></th>
                                    <th style={{ width: '50px' }} className="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    record.length > 0 ? <>{
                                        record.map((data, ID) => (
                                            <tr key={ID}>
                                                <td className="text-center">
                                                    {data.SeqNo}
                                                </td>
                                                <td>
                                                    {/* <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        // disabled={true}
                                                        value={data.Description}
                                                        onChange={(e) => this.onDescriptionChange(e, data.SeqNo)}
                                                    /> */}
                                                    <textarea className="form-control" value={data.Description} onChange={(e) => this.onDescriptionChange(e, 1, data.SeqNo)}></textarea>
                                                </td>
                                                <td className="text-center" >
                                                    {data.parent_id == 0 && <button
                                                        // onClick={() => this.updateExhibitionPaymentConfigration()}   
                                                        onClick={() => this.onAddSubNote(data.SeqNo, 1)}
                                                        class="btn rounded-1 btn-aqua  mt-2">Add SubNote</button>}
                                                </td>
                                                <td className="text-center">
                                                    {<button
                                                        // onClick={() => this.updateExhibitionPaymentConfigration()}
                                                        onClick={() => this.onDelete(ID, data.SeqNo, data.parent_id, 1)}
                                                        class="btn rounded-0 btn-danger mt-2">Delete</button>}
                                                </td>
                                            </tr>
                                        ))}
                                    </> :
                                        <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div></>
        )
    }

    updatePartnerMaster() {
        const { ExihibitionID, partnerList } = this.state

        this.setState({ isLoading: true })
        // console.log('waterMarkFilePath', waterMarkFilePath)
        this.props.updatePartnerMaster_action(ExihibitionID, partnerList)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("data updated successfully")
                    this.getPartnerMaster()
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    updateNote() {
        const { isLoading, partnerList, allNoteData, mode, ExihibitionID, partnerOfferNoteList, selectedPartnerId, partnerTandCNoteList } = this.state
        var selectedPartnerIndex = 0
        var noOfelements = 0
        for (var i = 0; i < allNoteData.length; i++) {
            if (allNoteData[i].PartnerTypeID == selectedPartnerId) {
                selectedPartnerIndex = i
                break
            }
        }
        for (var i = 0; i < allNoteData.length; i++) {
            if (allNoteData[i].PartnerTypeID == selectedPartnerId) {
                noOfelements = noOfelements + 1
            }
        }
        var newArr = [
            ...partnerOfferNoteList,
            ...partnerTandCNoteList
        ]
        // allNoteData.splice(selectedPartnerIndex, noOfelements, newArr.toString())
        var firstArr = allNoteData.slice(0, selectedPartnerIndex)
        var lastArr = allNoteData.slice(selectedPartnerIndex + noOfelements)
        var finalArr = [
            ...firstArr,
            ...newArr,
            ...lastArr
        ]

        var err = false
        for (var i = 0; i < newArr.length; i++) {
            if (newArr[i].Description == '' || newArr[i].Description == null) {
                err = true
                break
            }
        }
        console.log(finalArr, firstArr, lastArr)
        if (err) {
            toastError("Description cannont be blank")
        } else {
            this.setState({ isLoading: true })
            this.props.updatePartnerNote_action(ExihibitionID, finalArr)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("data updated successfully")
                        this.setState({
                            selectedPartnerId: '', mode: 0
                        }, () => {
                            this.getPartnerMaster()
                        })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    onNewNote(id) {
        const { isLoading, partnerList, selectedPartnerId, mode, partnerOfferNoteList, partnerTandCNoteList } = this.state
        var obj = {
            'PartnerTypeID': selectedPartnerId,
            'Description': '',
            'SeqNo': id == 0 ? `${parseInt(partnerOfferNoteList[partnerOfferNoteList.length - 1].SeqNo) + 1}` : `${parseInt(partnerTandCNoteList[partnerTandCNoteList.length - 1].SeqNo) + 1}`,
            'IsOffer': id == 0,
            'IsTermAndCondition': id == 1,
            'parent_id': 0
        }
        if (id == 0) {
            partnerOfferNoteList.push(obj)
        } else if (id == 1) {
            partnerTandCNoteList.push(obj)
        }
        this.setState({
            partnerTandCNoteList: partnerTandCNoteList,
            partnerOfferNoteList: partnerOfferNoteList
        })
    }

    render() {
        const { isLoading, partnerList, mode, partnerOfferNoteList, partnerTandCNoteList } = this.state
        console.log(partnerOfferNoteList)
        return (<>

            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}

            <ToastContainer />
            <HeaderWithLogo />
            <>
                <AdminDrawer />
                {mode == 1 ? <div className="main-container p-2">
                    <div class="row mt-3">
                        <h5>Offer Notes</h5>
                        {this.renderOfferNotesTable(partnerOfferNoteList)}
                        <div class="col-md-12">
                            <button
                                // onClick={() => this.updateExhibitionPaymentConfigration()} 
                                onClick={() => this.onNewNote(0)}
                                class="btn rounded-1 btn-aqua mt-3 " style={{ padding: "5px 7px", float: 'right', marginRight: "25px" }}>Add Offer Note</button>
                        </div>

                        <h5 className='mt-3'>Terms and Conditions Notes</h5>
                        {this.renderTandCNotesTable(partnerTandCNoteList)}
                        <div class="col-md-12">
                            <button
                                // onClick={() => this.updateExhibitionPaymentConfigration()} 
                                onClick={() => this.onNewNote(1)}
                                class="btn rounded-1 btn-aqua mt-3" style={{ padding: "5px 7px", float: 'right', marginRight: "25px" }}>Add Terms and Conditions  Note</button>
                        </div>
                        <div class="col-md-12">

                            <div style={{ marginTop: '50px' }}>
                                <button
                                    onClick={() => this.updateNote()}
                                    disabled={!this.getWriteAccess()}
                                    class="btn rounded-1 btn-aqua" style={{ padding: "5px 7px", marginLeft: "10px", width: "100px" }}>Save</button>
                                <button
                                    // onClick={() => this.updateExhibitionPaymentConfigration()} 
                                    onClick={() => this.setState({
                                        selectedPartnerId: '', mode: 0
                                    })}
                                    class="btn rounded-1 btn-aqua mt-3" style={{ padding: "5px 7px", marginLeft: "10px", width: "100px" }}>Back</button>
                                {/* <button onClick={this.handleBack} class="btn rounded-0 btn-danger mt-3" style={{ padding: "5px 7px", marginLeft: "10px", width: "100px" }}>Back</button> */}
                            </div>
                        </div>

                    </div>
                </div> : <div className="main-container p-2">
                    {this.renderTable(partnerList)}
                    <div class="row">

                        <div class="col-md-12 px-0">

                            <div >
                                <button
                                    onClick={() => this.updatePartnerMaster()} disabled={!this.getWriteAccess()}
                                    class="btn rounded-1 btn-aqua mt-2" style={{ marginLeft: "20px", width: "100px" }}>Save</button>
                                {/* <button onClick={this.handleBack} class="btn rounded-0 btn-danger mt-3" style={{ padding: "5px 7px", marginLeft: "10px", width: "100px" }}>Back</button> */}
                            </div>
                        </div>
                    </div>
                </div>}
            </>


        </>)
    }
}
export default withRouter(connect(null, { fill_master_action, getPartnerMaster_action, updatePartnerMaster_action, updatePartnerNote_action, getPartnerNote_action })(PartnerMaster));